import { emailConstants } from '../constants/actionTypes'

export const updateForProposalViewFromEmail = (errorMessage) => ({
  type: emailConstants.EMAIL_PROPOSAL_VIEW,
})
